import React from 'react';
import styles from './MainLayout.module.css';
import Header from 'components/Header';
import Footer from 'components/Footer';
import { Outlet } from 'react-router-dom';

const MainLayout = () => {
  return (
    <div className={styles.wrapper}>
      <Header />

      <div className={styles.content}>
        <Outlet />
      </div>
      
      <Footer />
    </div>
  );
};

export default MainLayout;
